export default "__VITE_ASSET__d729c9c9__"